import { useReducer, useEffect } from 'react'
import * as domain from '@packages/domain'
import { Configuration } from '~/store'

/**
 * Simple hook that provides state and dispatch
 * Similar to Redux's useSelector + useDispatch pattern
 */
export const useConfigurationState = (configuratorData: domain.Configurator.Type) => {
  const [state, dispatch] = useReducer(Configuration.reducer, Configuration.initialState)

  // Initialize configurator data when component mounts
  useEffect(() => {
    dispatch(Configuration.configuratorInitialized(configuratorData))
  }, [configuratorData])

  return [state, dispatch] as const
}
